










































import { Component } from 'vue-property-decorator';
import Routes from '@/util/Routes';
import { CategoryDto } from '@/api';
import AbstractFlyoutMenu from '@/views/layout/AbstractFlyoutMenu';
import { getModule } from 'vuex-module-decorators';
import { CmsStore } from '@/stores/cms.store';

@Component({})
export default class MobileFlyoutMenu extends AbstractFlyoutMenu {
  private cmsStore = getModule(CmsStore, this.$store);
  private routes = Routes;
  private currentCategory: CategoryDto | null = null;

  get menuTitle(): string {
    return this.cmsStore.header?.categoryMenuTitle ?? '';
  }

  private getSubCategoryParentOf(categoryId: string): CategoryDto[] {
    return this.categoryStore.categories.filter((cats) => cats.category.parentId === categoryId).map((x) => x.category);
  }

  private getSubSubCategoryOf(categoryId: string): CategoryDto[] {
    const entry = this.categoryStore.categories.find((cats) => cats.category.id === categoryId);
    if (entry) {
      return entry.children;
    }
    return [];
  }

  public async mounted() {
    if (this.categoryStore.categories.length === 0) {
      await this.categoryStore.fetchAllCategories();
    }
  }

  private close(): void {
    this.$emit('close');
  }


  private back() {
    if (this.currentCategory?.parentId !== '') {
      const cat = this.categoryStore.rootCategories.find((x) => x.id === this.currentCategory?.parentId);
      if (cat) {
        this.currentCategory = cat;
      }
    } else {
      this.currentCategory = null;
    }
  }
}
